import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

function useTimeout(callback, delay) {
  var dependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var savedCallback = useRef(); // Remember the latest callback.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setTimeout(tick, delay);
      return function () {
        return clearTimeout(id);
      };
    }

    return function () {};
  }, [delay].concat(_toConsumableArray(dependencies))); // Return args for testing.

  return {
    callback: callback,
    delay: delay
  };
}

useTimeout.propTypes = {
  callback: PropTypes.func.isRequired,
  delay: PropTypes.number.isRequired
};
export default useTimeout;